// Resolve entry-flow copy for the auth door's language and turn stable error
// codes (the server's, or the client checks in entry-validation.ts) into text.
// New and per-field messages live in the 24-language `entry` namespace; codes
// that already had 24-language copy keep it in strings.ts.
import entryCopy, { type EntryCopy, type EntryCopyKey } from '@/i18n/ns/entry';
import { namespaceCopyFor } from '@/i18n/ns';
import { AUTH_STRINGS, authLangFor, type AuthStrings } from './strings';

export function entryCopyFor(locale: string): { entry: EntryCopy; auth: AuthStrings } {
  const language = authLangFor(locale);
  return { entry: namespaceCopyFor(entryCopy, language), auth: AUTH_STRINGS[language] };
}

const ENTRY_ERROR_KEYS: Readonly<Record<string, EntryCopyKey>> = {
  company_name_required: 'companyRequired',
  invalid_company_details: 'companyTooLong',
  email_required: 'emailRequired',
  email_invalid: 'emailInvalid',
  work_email_required: 'workEmailRequired',
  password_required: 'passwordRequired',
  password_too_short: 'passwordTooShort',
  password_too_long: 'passwordTooLong',
  password_compromised: 'passwordCompromised',
  password_mismatch: 'passwordMismatch',
  reset_expired: 'resetExpired',
};

export function entryErrorText(code: string, entry: EntryCopy, auth: AuthStrings): string {
  if (Object.hasOwn(ENTRY_ERROR_KEYS, code)) return entry[ENTRY_ERROR_KEYS[code]];
  return Object.hasOwn(auth.errors, code) ? auth.errors[code] : auth.errors.generic;
}
